import { Money, type Currency, type PaymentPromiseInput } from '@chukua/common';

/** What the form holds: an amount the way a person types it ("1,500.50"), in the invoices' currency. */
export interface PromiseFormValues {
  followUpId: string;
  /** YYYY-MM-DD from the date picker. */
  promisedDate: string;
  amount: string;
  invoiceIds: string[];
}

/** Null when the text is not a positive amount the currency can hold, so the form can say so instead of the server. */
export function parseAmountMinor(amount: string, currency: Currency): number | null {
  const cleaned = amount.replace(/[,\s]/g, '');
  if (!/^\d+(\.\d+)?$/.test(cleaned)) return null;
  try {
    const { amountMinor } = Money.parse(cleaned, currency);
    return amountMinor > 0 ? amountMinor : null;
  } catch {
    return null;
  }
}

export function toPromiseInput(values: PromiseFormValues, currency: Currency): PaymentPromiseInput | null {
  const amountMinor = parseAmountMinor(values.amount, currency);
  if (amountMinor === null) return null;
  return { followUpId: values.followUpId, promisedDate: values.promisedDate, amountMinor, currency, invoiceIds: values.invoiceIds };
}

/** Invoices of a different currency than the first one picked cannot join the same promise. */
export function isInvoiceSelectable(invoiceCurrency: string, pickedCurrency: string | null): boolean {
  return pickedCurrency === null || invoiceCurrency === pickedCurrency;
}
